import "../assets/styles/StarAnimation.css";
import star from "../assets/images/star.svg";

const StartAnimation = ({ status }) => {
  return (
    <div className={"bubbles " + status}>
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
      <img src={star} className="bubble" alt="" />
    </div>
  );
};

export default StartAnimation;
